var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalCouncil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.881,
    height: 34.69,
    viewBox: "0 0 34.881 34.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "city-council_1_",
    "data-name": "city-council (1)",
    transform: "translate(0 -1.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65311",
    "data-name": "Path 65311",
    d: "M221.81,218.48a2.633,2.633,0,1,0-2.633-2.633A2.636,2.636,0,0,0,221.81,218.48Zm0-4.244a1.611,1.611,0,1,1-1.611,1.611A1.613,1.613,0,0,1,221.81,214.237Z",
    transform: "translate(-204.245 -197.388)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65312",
    "data-name": "Path 65312",
    d: "M250.495,235.534a.509.509,0,0,0,.383.174h.537a.511.511,0,0,0,0-1.022h-.071v-.305a.511.511,0,0,0-1.022,0v.77A.509.509,0,0,0,250.495,235.534Z",
    transform: "translate(-233.267 -216.636)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65313",
    "data-name": "Path 65313",
    d: "M70.046,330.915h2.64a.511.511,0,0,0,.511-.511v-2.425a1.831,1.831,0,0,0-3.662,0V330.4A.511.511,0,0,0,70.046,330.915Zm.511-2.936a.809.809,0,0,1,1.618,0v1.914H70.557Z",
    transform: "translate(-64.798 -302.627)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65314",
    "data-name": "Path 65314",
    d: "M70.046,409.607h2.64a.511.511,0,0,0,.511-.511v-2.425a1.831,1.831,0,0,0-3.662,0V409.1A.511.511,0,0,0,70.046,409.607Zm.511-2.936a.809.809,0,0,1,1.618,0v1.914H70.557Z",
    transform: "translate(-64.798 -375.958)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65315",
    "data-name": "Path 65315",
    d: "M391.369,330.915h2.64a.511.511,0,0,0,.511-.511v-2.425a1.831,1.831,0,0,0-3.662,0V330.4A.511.511,0,0,0,391.369,330.915Zm.511-2.936a.809.809,0,1,1,1.618,0v1.914H391.88Z",
    transform: "translate(-364.23 -302.627)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65316",
    "data-name": "Path 65316",
    d: "M391.369,409.607h2.64a.511.511,0,0,0,.511-.511v-2.425a1.831,1.831,0,0,0-3.662,0V409.1A.511.511,0,0,0,391.369,409.607Zm.511-2.936a.809.809,0,0,1,1.618,0v1.914H391.88Z",
    transform: "translate(-364.23 -375.958)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65317",
    "data-name": "Path 65317",
    d: "M34.37,35.065h-.034a4.872,4.872,0,0,0,.449-2.419,10.682,10.682,0,0,0-.727-4.089A2.985,2.985,0,0,0,32.342,26.7V21.176a.87.87,0,0,0,.766-.862V18.951a.87.87,0,0,0-.869-.869h-3.6a.511.511,0,0,0,0,1.022h3.452V20.16H23.674V19.1h4.917a.511.511,0,0,0,0-1.022H23.674V14.919H24.3a.87.87,0,0,0,.869-.869V12.687a.87.87,0,0,0-.869-.869h-.7a6.214,6.214,0,0,0-5.483-5.262V5.221l.355.024q.26.017.522.017a7.866,7.866,0,0,0,1.369-.12A6.829,6.829,0,0,1,22.5,5.1l.556.078a.511.511,0,0,0,.582-.506V2.056a.511.511,0,0,0-.44-.506l-.556-.078a7.847,7.847,0,0,0-2.455.045,6.852,6.852,0,0,1-1.645.089l-.9-.06a.511.511,0,0,0-.545.51V6.529a6.231,6.231,0,0,0-5.822,5.29h-.7a.87.87,0,0,0-.869.869V14.05a.87.87,0,0,0,.869.869h.629v3.163H2.642a.87.87,0,0,0-.869.869v1.363a.87.87,0,0,0,.766.862V26.7c-1.456.425-2.5,2.837-2.5,5.942a4.869,4.869,0,0,0,.45,2.421.511.511,0,0,0,.026,1.021H34.37a.511.511,0,0,0,0-1.022ZM11.207,21.182v1.136H9.59a.858.858,0,0,0-.857.857v1.243a.858.858,0,0,0,.857.857h.383V31.63a2.7,2.7,0,0,0-.892,3.333H3.561V21.182Zm4.76,4.094v9.687H13.98a2.7,2.7,0,0,0-.892-3.333V25.276h2.88Zm5.826,0V31.63a2.7,2.7,0,0,0-.892,3.333H19.083V25.276Zm2.792,9.687H22.116a1.66,1.66,0,0,1-.441-1.133,1.676,1.676,0,1,1,3.352,0A1.66,1.66,0,0,1,24.585,34.963Zm-.7-3.777a2.7,2.7,0,0,0-1.072,0v-5.91h1.072Zm-5.826,3.777H16.989V25.276h1.072Zm-7.765,0a1.66,1.66,0,0,1-.441-1.133,1.676,1.676,0,1,1,3.352,0,1.66,1.66,0,0,1-.441,1.133Zm1.77-3.777a2.7,2.7,0,0,0-1.072,0v-5.91h1.072Zm21.7,1.459a3.21,3.21,0,0,1-.441,2.08,1.357,1.357,0,0,1-.98.237V27.832c.74.55,1.422,2.374,1.422,4.814ZM31.32,21.182V34.963H25.8a2.7,2.7,0,0,0-.892-3.333V25.276h.383a.858.858,0,0,0,.857-.857V23.176a.858.858,0,0,0-.857-.857H23.674V21.182ZM18.121,2.6l.355.024a7.867,7.867,0,0,0,1.891-.1A6.827,6.827,0,0,1,22.5,2.484l.116.016V4.087a7.843,7.843,0,0,0-2.43.048,6.853,6.853,0,0,1-1.645.089L18.121,4.2ZM10.731,12.84h3.74a.511.511,0,1,0,0-1.022H12.313a5.211,5.211,0,0,1,10.254,0H14.516a.511.511,0,0,0,0,1.022h9.634V13.9H10.731Zm11.92,2.078v7.4H13.388a.511.511,0,0,0,0,1.022H25.127v.914H9.754V23.34h4.59a.511.511,0,0,0,0-1.022H12.229v-7.4ZM2.795,19.1h8.412V20.16H2.795Zm-.256,8.728v7.131c-.5,0-.832-.031-1.041-.237a3.21,3.21,0,0,1-.441-2.08C1.057,30.268,1.77,28.392,2.539,27.832Z",
    transform: "translate(0)",
    fill: "#06233d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalCouncil);
export default __webpack_public_path__ + "static/media/localCouncil.1155e117e2ebddd229e8106cf4d02ca2.svg";
export { ForwardRef as ReactComponent };